// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__lUrmk","jumbotron":"App_jumbotron__1waZx","container":"App_container__mIaXH","footer":"App_footer__W84u6"};